import type { UploadFile } from '@/types/tis-cms/types';

export const getImageAlt = (img: UploadFile, title?: string) =>
  img.alternativeText ?? title ?? '';

export const isPortraitImage = (img: UploadFile) => {
  const width = img.width ?? 640;
  const height = img.height ?? 360;
  return width < height;
};

export const isSameRatioImages = (img1: UploadFile, img2: UploadFile) =>
  isPortraitImage(img1) === isPortraitImage(img2);
